import React from 'react';
import { createPortal } from 'react-dom';
import { usePortalDropdown } from './usePortalDropdown';

/**
 * Renders dropdown menu content via portal into #branches-dropdown-portal.
 * Escapes parent CSS transform: scale() so menu appears at normal size.
 */
export function PortalDropdownMenu({
  children, show, toggleRef, onClose, className,
}) {
  const { setMenuRef, menuStyle } = usePortalDropdown(show, toggleRef, onClose);

  // Lazy lookup — tolerant of render order, always gets fresh reference
  const portalRoot = show ? document.getElementById('branches-dropdown-portal') : null;

  if (!show || !portalRoot || !menuStyle) return null;

  return createPortal(
    <div
      ref={setMenuRef}
      className={`dropdown-menu show ${className || ''}`}
      style={menuStyle}
      role="menu"
    >
      {children}
    </div>,
    portalRoot,
  );
}
